import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';

import { Store } from '@ngrx/store';

import { TranslatePipe } from '@recruitee/i18n';
import type { ResultGroup, ResultRating } from '@recruitee/interview-results-types';
import type { Placement } from '@recruitee/placements-types';
import {
  HiddenEvaluationsInfoboxComponent,
  UnbiasedHiringModule,
} from '@recruitee/unbiased-hiring';
import { TruncateComponent } from '@recruitee/user-interface';

import { OverallItemRowComponent } from './overall-item-row/overall-item-row.component';

@Component({
  selector: 'rt-interview-result-summary-overall-item',
  templateUrl: 'interview-result-summary-overall-item.component.html',
  styleUrls: ['./interview-result-summary-overall-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TruncateComponent,
    UnbiasedHiringModule,
    OverallItemRowComponent,
    TranslatePipe,
    HiddenEvaluationsInfoboxComponent,
  ],
})
export class InterviewResultSummaryOverallItemComponent {
  @Input() public group: ResultGroup;
  @Input() public hasMultiplePlacements: boolean;
  @Input() public currentUserAvailablePlacements: Placement[] = [];
  @Input() public hasAccessToAllJobOffers?: boolean;

  public counterClick = output();

  public totalRatingsCount: number;

  constructor(private store: Store) {}

  public ngOnInit(): void {
    this.totalRatingsCount = this.getTotalRatingsCount().reduce((acc, value) => acc + value);
  }

  public hasAccessToJob(offerId: number): boolean {
    return (
      this.hasAccessToAllJobOffers ||
      this.currentUserAvailablePlacements.some(placement => placement.offerId === offerId)
    );
  }

  public trackBy(index: number, item: ResultRating): string {
    return item.rating + index;
  }

  public onCounterClick() {
    this.counterClick.emit();
  }

  private getTotalRatingsCount(): number[] {
    return [...this.group.ratings, this.group.hiddenRatings].map(rating => rating?.count || 0);
  }
}
